import { ScheduledRoute, Delivery } from '@/types/schema';

export default (model: ScheduledRoute | Delivery) => {
  const items = [model.truck, model.trailer]
    .filter((item) => !!item)
    .map((item) => (item ? item.name : ''))
    .join(' + ');
  return items || 'Not Assigned';
};
